import React from "react"
import Slider from "react-slick"
import { Typography } from "@mui/material"
import { Box, useTheme } from "@mui/system"

import image from "assets/images/imagePlaceholder.png"
import MenuImageDisplayer from "components/Menu"
import styles from "./card.module.scss"
import { useHistory } from "react-router-dom"
import { useDispatch } from "react-redux"
import { hotelAction } from "redux/hotel/slice/user"
import { getDynamicFieldsAction } from "redux/hotel/action"

function CategoriesCard({ category }) {
  const theme = useTheme()
  const dispatch = useDispatch()
  const history = useHistory()
  const mediaMatch = window.matchMedia("(max-width: 2000px) and (min-width: 1700px)")

  const handleMenuItem = (items) => {
    dispatch(hotelAction.setHotelService(items))
    history.push(`/hotels/dashboard/hotel-services`)
    dispatch(getDynamicFieldsAction(items?.id))
  }

  const slidesToShow = 3
  const shouldLoop = category.length > slidesToShow

  const settings = {
    dots: true,
    infinite: shouldLoop,
    speed: 500,
    arrows: false,
    slidesToShow: Math.min(slidesToShow, category.length),
    slidesToScroll: Math.min(slidesToShow, category.length),
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: Math.min(2, category.length),
          slidesToScroll: Math.min(2, category.length),
          infinite: category.length > 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: category.length > 1
        }
      }
    ]
  }

  return (
    <>
      {category?.length ? (
        <Box sx={{ mt: 2, cursor: "pointer" }}>
          <Slider {...settings}>
            {category.map((items, idx) =>
              items ? (
                <Box key={idx} px={1}>
                  <Box
                    className={styles.featureItemContainer}
                    onClick={() => handleMenuItem(items)}>
                    <Box
                      className={
                        mediaMatch.matches
                          ? styles.categoryImagePrimary
                          : styles.categoryImageSecondary
                      }>
                      {items?.image_url ? (
                        <MenuImageDisplayer image={items?.image_url} />
                      ) : (
                        <img src={image} className={styles.wineImage} />
                      )}
                    </Box>
                    <Box className={styles.wineDetail}>
                      <Typography
                        variant="caption2"
                        color={theme.palette.secondary.main}
                        textTransform="uppercase">
                        {items?.name}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              ) : null
            )}
          </Slider>
        </Box>
      ) : (
        <Typography variant="h2" textAlign="center" style={{ opacity: 0.6 }}>
          No Category Found
        </Typography>
      )}
    </>
  )
}

export default CategoriesCard
